import React, { useContext, useCallback, useState } from "react";
import { StyleSheet }                               from "react-native";
import palette                                      from "~/styles/palette";
import ExpandableCard                               from "../../ExpandableCard/index.web";
import ParticipantContext                           from "../../../contexts/ParticipantContext";

export default function ParticipantEstimates() {
  const { customer, getCustomer } = useContext(ParticipantContext);
  const { estimates = [] } = customer || {};
  
  if (!customer) return null;

  return (
    <ExpandableCard
      title="Estimates"
      icon="file"
      badge={estimates?.length}
      onOpen={getCustomer}
    ></ExpandableCard>
  );
}

const styles = StyleSheet.create({
  participant_details__estimates__container: {
    fontWeight: "500",
    color: palette.grey,
    paddingHorizontal: 16,
    borderColor: palette.lighter_grey,
    borderBottomWidth: 1,
    overflow: "hidden",
    transitionDuration: "150ms",
    transitionProperty: "height",
    transitionTimingFunction: "ease-out",
    height: 320,
  },
});
